<div class="footer">
  <div class="flex flex-row items-center">
    <a href="https://www.producthunt.com/posts/terminal-gif-maker-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-terminal&#0045;gif&#0045;maker&#0045;2" target="_blank" rel="noreferrer">
      <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=381584&theme=light" alt="Terminal&#0032;Gif&#0032;Maker - Creating&#0032;code&#0032;samples&#0032;in&#0032;simple&#0032;terminal&#0032;interface | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" />
    </a>
  </div>
  <div class="personal-accounts">
    Personal Accounts
    <a class="footer-link" href="https://github.com/muhammedikinci" target="_blank" rel="noreferrer">
      <img class="w-6 h-6 mr-2" src="/images/github.webp" alt="github" /> muhammedikinci
    </a>

    <a class="footer-link" href="https://www.linkedin.com/in/turhan-huseynov/" target="_blank" rel="noreferrer">
      <img class="w-6 h-6 mr-2" src="/images/linkedin.webp" alt="linkedin" /> turhan-huseynov
    </a>
  </div>
</div>

<style lang="postcss" scoped>
  .footer {
    @apply flex justify-center relative pt-12 pb-4 items-end;
  }

  .personal-accounts {
    @apply flex font-bold text-white ml-48;
  }

  .footer-link {
    @apply flex font-bold text-white visited:text-white underline underline-offset-4 ml-4;
  }
</style>
